import React, { useEffect, useState } from "react";
import { Linking, Text, View } from "react-native";
import { PlatformEvent, PlatformOffer, SelectedOutcome } from "@freeplay/shared-code";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { GlobalStyles } from "./style/Style";
import { ButtonSize, ButtonTheme, RoundedButton } from "./buttons/roundedButton/RoundedButton";

interface OneDollarBetProps {
    platformEvents: PlatformEvent[];
    entry: SelectedOutcome[];
    buttonText?: string;
    buttonURL?: string;
}

export const BetDisplay: React.FC<OneDollarBetProps> = ({ platformEvents, entry, buttonText, buttonURL }) => {
    const [money, setMoney] = useState<number>(0);
    const styles = useDynamicStyles(generateStyles);

    const stake = 10;

    useEffect(() => {
        setMoney(0);
        const gameEntry: PlatformOffer[] = platformEvents.flatMap((entry: PlatformEvent) =>
            entry.platformOffers.map((item) => item),
        );
        if (entry && entry.length === gameEntry.length) {
            gameEntry.forEach((localEntry, index: number) => {
                let odds: number;
                if (localEntry.platformOutcomes[0].id === entry[index].platformOutcomeId) {
                    odds = parseInt(localEntry.platformOutcomes[0].oddsAmerican);
                } else {
                    odds = parseInt(localEntry.platformOutcomes[1].oddsAmerican);
                }
                if (odds > 0) {
                    setMoney((money) => money + stake + stake * (odds / 100));
                } else {
                    odds = odds * -1;
                    setMoney((money) => money + stake + stake / (odds / 100));
                }
            });
        }
    }, [platformEvents, entry]);

    return (
        <>
            <Text style={styles.subheading}>A bet on your picks would pay</Text>
            <View style={[styles.container, buttonText && buttonURL && styles.hasButton]}>
                <View style={styles.column}>
                    <Text style={styles.columnHeader}>Bet Amount</Text>
                    <Text style={styles.columnValue}>${stake}</Text>
                </View>
                <View style={styles.column}>
                    <Text style={styles.columnHeader}>Bet Amount</Text>
                    <Text style={styles.columnValue}>${money.toFixed(2)}</Text>
                </View>
            </View>
            {buttonText && buttonURL && buttonURL !== "" && (
                <View style={styles.buttonContainer}>
                    <RoundedButton
                        config={{
                            buttonText: buttonText,
                            size: ButtonSize.LARGE,
                            width: 250,
                            height: 50,
                            theme: ButtonTheme.CTA,
                            margin: { bottom: 0, left: 0, right: 0, top: 0 },
                        }}
                        testID={`next-game-button`}
                        onPress={() => Linking.openURL(buttonURL)}
                    />
                </View>
            )}
        </>
    );
};

const generateStyles = () => {
    return EStyleSheet.create({
        container: {
            width: "100%",
            maxWidth: 300,
            flexDirection: "row",
            height: 60,
            backgroundColor: () => EStyleSheet.value(GlobalStyles.BET_DISPLAY_BACKGROUND),
            borderRadius: () => EStyleSheet.value(GlobalStyles.BORDER_RADIUS),
        },
        hasButton: {
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0,
        },
        buttonContainer: {
            width: "100%",
            maxWidth: 300,
            height: 70,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: () => EStyleSheet.value(GlobalStyles.BET_DISPLAY_CTA_BACKGROUND),
            borderBottomRightRadius: () => EStyleSheet.value(GlobalStyles.BORDER_RADIUS),
            borderBottomLeftRadius: () => EStyleSheet.value(GlobalStyles.BORDER_RADIUS),
        },
        column: {
            width: "50%",
            justifyContent: "center",
            alignItems: "center",
            paddingHorizontal: 10,
        },
        columnHeader: {
            fontSize: 18,
            lineHeight: 18,
            color: () => EStyleSheet.value(GlobalStyles.BET_DISPLAY_HEADER),
            fontFamily: () => EStyleSheet.value(GlobalStyles.HEADER_FONT),
        },
        columnValue: {
            fontSize: 24,
            lineHeight: 24,
            fontWeight: "800",
            color: () => EStyleSheet.value(GlobalStyles.BET_DISPLAY_AMOUNT),
        },
        subheading: {
            fontSize: 14,
            fontWeight: "700",
            textAlign: "center",
            marginBottom: 5,
            color: () => EStyleSheet.value(GlobalStyles.BASE_COLOUR),
            fontFamily: () => EStyleSheet.value(GlobalStyles.BASE_FONT),
        },

        winAmount: {
            fontSize: 100,
            lineHeight: 110,
            marginTop: 6,
            textAlign: "center",
            color: () => EStyleSheet.value(GlobalStyles.WIN_TEXT),
            fontFamily: () => EStyleSheet.value(GlobalStyles.HEADER_FONT),
        },
    });
};
